import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../../services/redirect'
import Paginations from '../../../services/paginations'
import EntryList from '../../../services/entries'
import Spinner from '../../../services/spinner'
import AlertMessage from '../../../services/alert'
import AlertConfirmation from '../../../services/confirmation'
import { DropdownComponent } from '../../../components/options'

import AccountDetailsComponent from './account-details'

import AuthDenied from '../../ErrorPage/denied'

export default function AuditCustomerComponent(props){

  const FormReference = useRef();

  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [spinoverlay,setspinoverlay] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }



  /*------------------------------------------------------
    ALERT CONFIRMATION
    {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
  -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
    if(data.intent=='confirm'){
      DeleteRecord(data.id);
    }
  }


  /*----------------------------------------
    LIST DATA TABLE
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  function handleSubmitForm(values, props){
    if(buttonclick==1){
      props.resetForm();
      TableList(pagenumber,search);
    }else{
      let value={
        account_number:values.account_number,
        account_name:values.account_name,
        email:values.email,
        date_added:values.date_added!=''?moment(new Date(values.date_added)).format('YYYY-MM-DD'):'',
        status:values.status,
        activities:values.activities,
        status_pricing:values.status_pricing,
        account_type:values.account_type,
      }
      TableList(pagenumber,value);
    }
  }
  function ReloadList(){
    let value={
      account_number:'',
      account_name:'',
      email:'',
      date_added:'',
      status:'',
      activities:'',
      status_quantity:'',
      status_pricing:'',
      account_type:'',
    }
    TableList(pagenumber,value);
  }

  const [search, setsearch]  = useState({
    account_number:'',
    account_name:'',
    email:'',
    date_added:'',
    status:'',
    activities:'',
    status_quantity:'',
    status_pricing:'',
    account_type:'',
	});
  const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	  function pagenumberfunction(page){
				setpagenumber(page);
        let values={
          account_number:FormReference.current.values.account_number,
          account_name:FormReference.current.values.account_name,
          email:FormReference.current.values.email,
          date_added:FormReference.current.values.date_added,
          status:FormReference.current.values.status,
          activities:FormReference.current.values.activities,
          status_quantity:FormReference.current.values.status_quantity,
          status_pricing:FormReference.current.values.status_pricing,
          account_type:FormReference.current.values.account_type,
        }
				TableList(page,values);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

        setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
        setspinner(true);

				let formData = new FormData();
				formData.append('type','list');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/administrations/audit-account/request.php',formData)
				.then(function (response) {
						let obj = response.data;
						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);
            setspinner(false);
				})
				.catch(function (error){
          setspinner(false);
				});
	}





  /*------------------------------------------------------
          DELETE FUNCTION
  -------------------------------------------------------*/
  function DeleteConfirmation(id){
    setconfirmcontent({intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, record will be deleted forever on the server.'}});
    setconfirm(true);
  }


  function DeleteRecord(id){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinoverlay(true);
    setconfirm(false);

    var typePost = 'delete';

    let formData = new FormData();
    formData.append('type',typePost);
    formData.append('id',id);
    axios.post('/admin/administrations/audit-account/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setspinoverlay(false);

        if(obj=='error_associated'){
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Delete Denied',text:'The record cannot be deleted because it is associated with another record.'}});
          setnotify(true);
          return false;
        }

        if(obj=='success'){
          setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully deleted.'}});
          setnotify(true);
          TableList(pagenumber,search);
          setTimeout(function() {setnotify(false);},2000);
        }else{
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Delete Failed',text:'Record not successfully deleted.'}});
          setnotify(true);
          setTimeout(function() {setnotify(false);},2000);
        }

    })
    .catch(function (error){
      setspinoverlay(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
}



/*------------------------------------------------------
   OTHER MODAL
  -------------------------------------------------------*/
  function ClassBody(data){
    if(data){
      document.body.classList.add("modal");
    }else{
      document.body.classList.remove("modal");
    }
  }
  const [details, setDetails] = useState(false);
  const [account, setAccount] = useState({});
  function CallbackFunction(data){
    if(data.close){
      ClassBody(false);
      setDetails(false);
    }
  }
  function OpenDetails(data){
    setAccount(data);
    ClassBody(true);
    setDetails(true);
  }





/*------------------------------------------------------
        DROPDOWN OPTIONS
-------------------------------------------------------*/
const [statusDropdown, setStatusDropdown] = useState([]);
const [onoffOptions, setonoffOptions] = useState([]);
const [accountTypeOptions, setaccountTypeOptions] = useState([]);
const [activityOptions, setActivityOptions] = useState([]);
const HandleOptions = async () => {
  const source = await DropdownComponent();
  setStatusDropdown(source.status);
  setonoffOptions(source.on_off_status);
  setaccountTypeOptions(source.account_type);
  setActivityOptions(source.activities);
}




  /*------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  -------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('nq5jzkvhb9wae84p2');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        // Load page when view permission is granted
        if(obj.view==1){
          TableList(pagenumber,search);
          HandleOptions();
        }
        setloader(false);

    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }

  useEffect(()=>{
    // Load Permission
    AuthPagesPermission();
  },[]);

  return (
    <React.Fragment>



       {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
       {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}

       {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
       {spinoverlay&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

       {(authPages['view']==0&&!loader)&&<AuthDenied/>}
       {(authPages['view']==1&&!loader)&&<React.Fragment>

       {details&&<AccountDetailsComponent data={account} callback={CallbackFunction}/>}


       <div className="app-page-title"><h1>Customers: Old Account</h1></div>
       <div className="app-body-wrapper">

       {/*---------------------------------------------------------
          SEARCH SECTION
         --------------------------------------------------------*/}
       <Formik
         initialValues={search}
         onSubmit={handleSubmitForm}
         innerRef={FormReference}
          >
         {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {

         const CustomDateAdded = ({ value, onClick }) => (
          <Input iconPosition='left' onClick={onClick} value={values.date_added}><i className='uil-calender icon'></i><input /></Input>
         );

         return(<React.Fragment>
           <div className="search-wrapper">
              <div className="search-body">
                <Form>
                  <Form.Group widths="equal">
                      <Field name="account_number">
                          {({ field, form }) => (
                          <Form.Field>
                            <label>Account Number</label>
                            <Input fluid {...field} onChange={handleChange}/>
                          </Form.Field>
                          )}
                        </Field>
                        <Field name="account_name">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Account Name</label>
                              <Input fluid {...field} onChange={handleChange} placeholder="Enter hint or word to search"/>
                            </Form.Field>
                            )}
                          </Field>
                       <Field name="email">
                           {({ field, form }) => (
                           <Form.Field>
                             <label>Email</label>
                             <Input fluid {...field} onChange={handleChange}/>
                           </Form.Field>
                           )}
                        </Field>

                        <Field name="date_added">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Date Modified</label>
                              <DatePicker
                                showYearDropdown
                                yearDropdownItemNumber={100}
                                scrollableYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                                selected={values.date_added!=''?new Date(values.date_added):null}
                                onChange={date => {
                                   var dateselected 	= moment(new Date(date)).format('MMMM DD, YYYY');
                                   setFieldValue('date_added',dateselected);
                                }}
                                customInput={<CustomDateAdded />}
                              />

                            </Form.Field>
                            )}
                        </Field>

    
                    </Form.Group>
                          <Form.Group widths="equal">
                            <Field name="account_type">
                              {({ field, form }) => (
                              <Form.Field>
                                <label>Account Type</label>
                                <Select selectOnBlur={false}
                                    {...field}
                                    options={accountTypeOptions}
                                    onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                              </Form.Field>
                              )}
                          </Field>
                          <Field name="activities">
                              {({ field, form }) => (
                              <Form.Field>
                                <label>Activities</label>
                                <Select selectOnBlur={false}
                                    {...field}
                                    options={activityOptions}
                                    onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                              </Form.Field>
                              )}
                          </Field>
                          <Field name="status_pricing">
                              {({ field, form }) => (
                              <Form.Field>
                                <label>Product Pricing</label>
                                <Select selectOnBlur={false}
                                    {...field}
                                    options={onoffOptions}
                                    onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                              </Form.Field>
                              )}
                          </Field>
                          <Field name="status">
                              {({ field, form }) => (
                              <Form.Field>
                                <label>Status</label>
                                <Select selectOnBlur={false}
                                    {...field}
                                    options={statusDropdown}
                                    onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                              </Form.Field>
                              )}
                          </Field>
                    </Form.Group>
                 </Form>
              </div>
              <div className="search-footer">
                <Button type="button" icon='sync alternate' size='tiny strong' className="LightGrayButton" content='Reset' onClick={() => buttonSubmit(1)}/>
                <Button type="button" icon='search' size='tiny strong' className="LightGrayButton" content='Search' onClick={() => buttonSubmit(2)}/>
                <button type="button" style={{'display':'none'}} ref={buttonEl} onClick={handleSubmit}></button>
              </div>
           </div>
        </React.Fragment>
         )}}
      </Formik>





      {/*---------------------------------------------------------
          TABLE LIST SECTION
         --------------------------------------------------------*/}
      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {!spinner&&<React.Fragment>
      <div className="tableWrapper">
       <div className="panel-table">

         <div className="panel-table-header">
           <div>{entry>0&&<EntryList entrycallback={entry} entryType={entrytype} lengthCallback={totaldata} callbackreload={listreload}/>}</div>
           <div><Button type="button" className="LightGrayButton" size='tiny' icon='sync alternate' content='Refresh' onClick={() => buttonSubmit(1)}/></div>
         </div>

         <div className="panel-table-body">
         <div className="table-responsive">
           <Table celled compact='very'>
             <Table.Header>
               <Table.Row verticalAlign='middle'>

                <Table.HeaderCell collapsing>Account Number</Table.HeaderCell>
                 <Table.HeaderCell>Account Name</Table.HeaderCell>
                 <Table.HeaderCell collapsing>Account Type</Table.HeaderCell>
                 <Table.HeaderCell>Email</Table.HeaderCell>
                 <Table.HeaderCell collapsing>Product Pricing?</Table.HeaderCell>
                 <Table.HeaderCell>Status</Table.HeaderCell>
                 <Table.HeaderCell collapsing>Date Modified</Table.HeaderCell>
                 <Table.HeaderCell collapsing>Modified By</Table.HeaderCell>
                 <Table.HeaderCell></Table.HeaderCell>

               </Table.Row>
             </Table.Header>

             <Table.Body>
                   {list.length==0&&<Table.Row negative>
                      <Table.Cell  colSpan='9' textAlign="center" className="noRecords">
                          <div><i className="info circle icon"></i></div>
                          <div>No record found on the server</div>
                      </Table.Cell>
                    </Table.Row>}
                   {list.map(function(data, key){
                     return <Table.Row key={key} verticalAlign='top'>
                         <Table.Cell>{data.account_number}</Table.Cell>
                         <Table.Cell>{data.account_name}</Table.Cell>
                         <Table.Cell>{parse(data.account_type)}</Table.Cell>
                         <Table.Cell collapsing>{data.email}</Table.Cell>
                         <Table.Cell collapsing>{parse(data.status_pricing)}</Table.Cell>
                         <Table.Cell collapsing>{parse(data.status_html)}</Table.Cell>

                         <Table.Cell collapsing className="now-wrapp">
                            <div className="descriptionTable">
                              <div>
                                  <h3>{data.date_added}</h3>
                                  <p>{data.time_added}</p>
                              </div>
                            </div>
                         </Table.Cell>

                         <Table.Cell collapsing>
                            <div className="profileTable">
                              <div><img src={data.account.image}/></div>
                              <div>
                                  <h3>{data.account.fullname}</h3>
                                  <p>{data.account.role_account}</p>
                              </div>
                            </div>
                         </Table.Cell>

                         <Table.Cell collapsing>

                         <Button  className='BlueButton' size='tiny' content='More Details' icon='info circle icon' onClick={()=>OpenDetails({
                            account_number:data.account_number,
                            account_name:data.account_name,
                            email:data.email,
                            password:data.password,
                            account_type:data.account_type,
                            address:data.addressList,
                            activities:data.activities,
                            status_pricing:data.status_pricing,
                            status:data.status_html,
                            comments:data.comments,
                            account:data.account,
                            date_added:data.date_added,
                            time_added:data.time_added
                         })} />

                         {/*<Button disabled={authPages['deleting']==0} className='RedButton' size='tiny' content='Delete' icon='uil-trash-alt icon' 
                          onClick={()=>DeleteConfirmation(data.id)} />*/}

                         </Table.Cell>
                     </Table.Row>
                   })}
               </Table.Body>
               {list.length>0&&
                 <Table.Footer fullWidth>
                     <Table.Row>
                     <Table.HeaderCell colSpan='9'>
                         <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
                     </Table.HeaderCell>
                     </Table.Row>
                 </Table.Footer>
               }
           </Table>
          </div>{/*.table-responsive*/}
         </div>{/*.panel-table-body*/}
        </div>{/*.panel-table*/}
        </div>

        </React.Fragment>}

       </div>{/*.app-body-wrapper*/}
       </React.Fragment>}
    </React.Fragment>
  )
}
